<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.products')">Products</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> Sync
        </h1>



        <div class="bg-white shadow sm:rounded-lg">
            <div v-if="completed" class="bg-green-300  px-2 py-3 text-green-900 text-center w-full">
                Syncing data completed successfully
            </div>
            <div class="px-4 py-5 sm:p-6">
                <div class="sm:flex sm:items-start sm:justify-between">
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Sync All Products
                        </h3>
                        <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
                            <p>
                                This action will fetch all the product items from the inventory system.
                            </p>
                            <p>Press the Sync button to start updating.</p>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                        <span class="inline-flex rounded-md shadow-sm">
                          <button type="button" @click="submit" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
                            <span v-if="sending">...please wait</span>
                            <span v-else>Sync now</span>
                          </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import Layout from '@/Shared/Admin/Layout'

  export default {
    metaInfo() {
      return { title: 'Sync Products' }
    },
    layout: Layout,
    data() {
      return {
        sending: false,
        completed: false
      }
    },
    methods: {
      submit() {
        this.sending = true
        this.$http.post(this.route('ajax.manage.products.sync'))
          .then(() => {
            this.sending = false;
            this.completed = true;
            setTimeout(() => {
              this.completed = false
            }, 1000)
          })
          .catch((error) => {
            console.log(error);
            this.sending = false;
            alert('There was a server error. Please check console log');

          })
      }
    },
  }
</script>
